import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <motion.section
        className="about-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="about-hero-content">
          <motion.h1
            className="about-hero-title"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            About the Artist
          </motion.h1>
        </div>
      </motion.section>

      <section className="about-content-section">
        <div className="about-container">
          <motion.div
            className="about-image-wrapper"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="about-image">
              <img src="/Lida.jpg" alt="Lida Caudle" />
            </div>
          </motion.div>

          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h2 className="about-title">Lida Caudle</h2>
            <div className="about-bio">
              <p>
                Lida Caudle is a Richmond, Virginia native and Charleston-based artist whose work reflects 
                authenticity, memory, and emotion through expressive forms and vibrant color. She studied at 
                the College of Charleston, earning a degree in Arts Management with a minor in Studio Art, a 
                combination that grounds her artistic practice in both creative expression and professional 
                discipline.
              </p>
              <p>
                Through The Lida Gallery, Lida shares original works and fine art prints, making her art 
                accessible while cultivating community through pop up events collaborating with other local 
                brands. Inspired by the natural rhythms of coastal life, her paintings balance creativity and 
                approachability with a distinct modern elegance.
              </p>
              <p>
                With plans to expand into a physical gallery representing other local artists, Lida continues 
                to develop a body of work that is both deeply personal and widely engaging.
              </p>
            </div>

            <div className="about-cta">
              <Link to="/original-work" className="cta-button primary">
                View Original Works
              </Link>
              <Link to="/contact" className="cta-button secondary">
                Get in Touch
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <motion.section
        className="gallery-about-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="gallery-about-content">
          <h2 className="gallery-about-title">About the Gallery</h2>
          <div className="gallery-about-text">
            <p>
              The Lida Gallery is an online gallery showcasing the work of Charleston-based artist Lida Caudle. Founded as a digital space, the gallery highlights original paintings and prints, offering collectors and art enthusiasts a direct connection to the artist's evolving body of work.
            </p>
            <p>
              While currently rooted online, The Lida Gallery reflects a vision that extends beyond the digital world. With plans to grow into a physical gallery space in the future, it seeks to create a place where creativity, community, and conversation can come together around the visual arts. The Lida Gallery is looking to represent local artists to provide a platform for other artists.
            </p>
            <p>
              Whether you are discovering Lida Caudle's work for the first time or adding to a collection, The Lida Gallery provides a curated and accessible way to experience original art, made with intention and care.
            </p>
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default About;


